import { render, staticRenderFns } from "./editClosingEntry.vue?vue&type=template&id=489ce6d2&scoped=true&"
import script from "./editClosingEntry.vue?vue&type=script&lang=js&"
export * from "./editClosingEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ce6d2",
  null
  
)

export default component.exports